import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';
import messages from '../../MLSummary.messages'

import styles from '../../MLSummary.module.scss'
import { IconButton } from '@jutro/legacy/components';

function MLVehicles({ data, vehicleDetailsOpen, interestTypeDisplayMap, getFormattedCurrency, show }) {
    const translator = useTranslator();
    const [didUpdate, setDidUpdate] = useState(false);

    if (_.isEmpty(data)) {
        return null;
    }

    const toggleVehicleDetails = (vehicle) => {
        vehicleDetailsOpen[vehicle.publicID_ML] = !vehicleDetailsOpen[vehicle.publicID_ML];
        setDidUpdate(!didUpdate);
    };


    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th />
                    <th>{translator(messages.Year)}</th>
                    <th>{translator(messages.Make)}</th>
                    <th>{translator(messages.Model)}</th>
                    <th>{translator(messages.Trim)}</th>
                    <th>{translator(messages.Vin)}</th>
                </tr>
            </thead>
        );
    }

    const generateVehicleDetails = (vehicle) => {
        if (vehicleDetailsOpen[vehicle.publicID_ML]) {
            return (
                <tr>
                    <td />
                    <td colSpan="5">
                        <div className="row">
                            {vehicle.additionalInterests_ML.map((additionalInterest) => {
                                return (
                                    <div className="col-md-3">
                                        <p><strong>{interestTypeDisplayMap[additionalInterest.type]}</strong></p>
                                        <p>{additionalInterest.policyAdditionalInterest.displayName}</p>
                                        {(additionalInterest.policyAdditionalInterest.primaryAddress.addressLine1)? 
                                            <p>{additionalInterest.policyAdditionalInterest.primaryAddress.addressLine1}</p> :
                                            <></>
                                        }
                                        <p>{`${additionalInterest.policyAdditionalInterest.primaryAddress.city  }, ${  additionalInterest.policyAdditionalInterest.primaryAddress.state}`}</p>
                                        <p>{additionalInterest.policyAdditionalInterest.primaryAddress.postalCode}</p>
                                        {(additionalInterest.contractNumber)?
                                            <p>{`Loan #: ${  additionalInterest.contractNumber}`}</p> :
                                            <></>
                                        }
                                    </div>
                                )
                            })}
                            <div className="col-md-3">
                                <p><strong>{translator(messages.GaragedAt)}</strong></p>
                                <p>{vehicle.garagingLocation_ML.addressLine1}</p>
                                <p>{`${vehicle.garagingLocation_ML.city  }, ${  vehicle.garagingLocation_ML.state}`}</p>
                                <p>{vehicle.garagingLocation_ML.postalCode}</p>
                            </div>
                            {vehicle.annualMileage !== undefined && vehicle.annualMileage > 0 &&
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.AnnualMileage)}</strong></p>
                                    <p>{vehicle.annualMileage}</p>
                                </div>
                            }
                            {(vehicle.value_ML && vehicle.value_ML.amount > 0) &&
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.Value)}</strong></p>
                                    <p>{getFormattedCurrency(vehicle.value_ML)}</p>
                                </div>
                            }
                        </div>
                    </td>
                </tr>

            );
        }
        return ( <></> );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.Vehicles)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((vehicle) => {
                            const iconStyle = vehicleDetailsOpen[vehicle.publicID_ML]? cx(styles.iconBlue, 'icon-accordion-down', 'icon-rotate-180') : cx(styles.iconBlue, 'icon-accordion-down')
                            return (
                                <>
                                    <tr>
                                        <td className="table-data-collapse">
                                            <h2 className="subsection-header">
                                                <IconButton
                                                    onClick={() => toggleVehicleDetails(vehicle)}
                                                    role="menuitem"
                                                    icon="icon-accordion-down"
                                                    className={iconStyle}
                                                />
                                            </h2>
                                        </td>
                                        <td><strong>{vehicle.year}</strong></td>
                                        <td>{vehicle.make}</td>
                                        <td>{vehicle.model}</td>
                                        <td>{vehicle.trim_ML}</td>
                                        {(vehicle.vin_ML) ? <td>{vehicle.vin_ML}</td> : <></>}
                                        {(vehicle.serial_ML && !vehicle.vin_ML) ? <td>{vehicle.serial_ML}</td> : <></>}
                                    </tr>
                                    <tr />
                                    {generateVehicleDetails(vehicle)}
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLVehicles.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    vehicleDetailsOpen: PropTypes.arrayOf(PropTypes.shape({})),
    interestTypeDisplayMap: PropTypes.arrayOf(PropTypes.shape({})),
    getFormattedCurrency: PropTypes.func,
    show: PropTypes.bool
};
MLVehicles.defaultProps = {
    data: [],
    vehicleDetailsOpen: [],
    interestTypeDisplayMap: [],
    getFormattedCurrency: _.noop,
    show: false
};
export default MLVehicles;
